import { useReveal } from '../lib/hooks'

/**
 * Fade-and-lift a block once it enters the viewport.
 *
 * `group` staggers the direct children instead of animating the wrapper, which
 * is what card grids want. Both modes are no-ops under
 * `prefers-reduced-motion: reduce` - see styles/motion.css.
 *
 * @param {object} props
 * @param {boolean} [props.group]
 * @param {number} [props.delay]  ms, ignored when `group` is set.
 * @param {string} [props.as]     Element to render, default 'div'.
 */
export default function Reveal({
  children,
  group = false,
  delay = 0,
  as: Tag = 'div',
  className = '',
  style,
  ...rest
}) {
  const [ref, visible] = useReveal()

  return (
    <Tag
      ref={ref}
      data-visible={visible}
      className={`${group ? 'reveal-group' : 'reveal'} ${className}`.trim()}
      style={delay ? { ...style, '--reveal-delay': `${delay}ms` } : style}
      {...rest}
    >
      {children}
    </Tag>
  )
}
